import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store'

import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

Vue.use(VueRouter);

const routes = [

  // {
  //   path: '/maintenance',
  //   name: "fund-announcements",
  //   beforeEnter() {
  //     window.open('https://affinhwangam.com/in-the-spotlight/fund-announcements', '_blank')
  //   },
  //   component: () => import('../pages/Maintenance.vue')
  // },

  {
    path: '/',
    component: () => import('../layouts/BaseLayout.vue'),
    children: [
      {
        name: 'homepage',
        path: '',
        component: () => import('../pages/Homepage.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        name: 'about-us',
        path: 'about-us',
        component: () => import('../pages/AboutUs.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        name: 'careers',
        path: 'careers',
        component: () => import('../pages/Careers.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        name: 'contact-us',
        path: 'contact-us',
        component: () => import('../pages/ContactUs.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        path: 'insights',
        component: {render: (c) => c('router-view')},
        children: [
          {
            name: 'index',
            path: '/',
            component: () => import('../pages/Insights/Main.vue')    ,
            meta: { showTransparentNavbar: true }
          },
          {
            name: 'fund-updates',
            path: '/blank',
            beforeEnter() {window.open('https://aham.com.my/in-the-spotlight/fund-announcements', '_blank')},
            // component: () => import('../pages/Insights/FundUpdates.vue'),
            meta: { showTransparentNavbar: true }
          },
          {
            name: 'dose-motivation',
            path: 'dose-motivation',
            component: () => import('../pages/Insights/DoseMotivation.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'dose-news',
            path: 'dose-news',
            component: () => import('../pages/Insights/DoseNews.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'daily-nav',
            path: '/blank',
            beforeEnter() {window.open('https://aham.com.my/invest-with-us/daily-fund-price', '_blank')},
            // component: () => import('../pages/Insights/DailyNAV.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'weekly-market-review',
            path: 'weekly-market-review',
            component: () => import('../pages/Insights/WeeklyMarketReview.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'weekly-market-review-id',
            path: 'weekly-market-review/:id',
            component: () => import('../pages/Insights/WeeklyMarketReview.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'articles',
            path: 'articles',
            component: () => import('../pages/Insights/Articles.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'articleinfull',
            path: 'articleinfull',
            component: () => import('../pages/Insights/ArticleInFull.vue'),
            meta: { showTransparentNavbar: true }
          },
          {
            name: 'list-of-funds',
            path: '/blank',
            beforeEnter() {window.open('https://aham.com.my/invest-with-us/list-of-funds', '_blank')},
            // component: () => import('../pages/Insights/ListOfFunds.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'fund-comparison',
            path: 'list-of-funds/fund-comparison',
            component: () => import('../pages/Insights/FundComparison.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'fund-updates-2',
            path: 'fund-announcements/:id',
            // component: () => import('../pages/Insights/Announcements.vue'),
            meta: { showTransparentNavbar: false }
          },
        ]
      },

      {
        path: 'resources',
        component: {render: (c) => c('router-view')},
        children: [
          {
            name: 'main',
            path: '/',
            component: () => import('../pages/Resources/Main.vue'),
            meta: { showTransparentNavbar: true }
          },
          {
            name: 'forms',
            path: 'forms',
            component: () => import('../pages/Resources/Forms.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'fundamentals',
            path: '/blank',
            beforeEnter() {window.open('https://aham.com.my/insights/fundamentals', '_blank')},
            // component: () => import('../pages/Resources/FUNDamentals.vue'),
            meta: { showTransparentNavbar: false }
          },
          // {
          //   name: 'fundamentals',
          //   path: '/blank',
          //   beforeEnter() { window.open('https://affinhwangam.com/insights/fundamentals', '_blank') },
          //   component: () => import('/')
          // },
          {
            name: 'information',
            path: 'information',
            component: () => import('../pages/Resources/Information.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'income-dist-details',
            path: 'income-dist-details',
            component: () => import('../pages/Resources/IncomeDistDetails.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'resources-income-dist-updates',
            path: '/blank',
            beforeEnter() {window.open('https://aham.com.my/invest-with-us/income-distribution-updates', '_blank')},
            // component: () => import('../pages/Resources/IncomeDistUpdates.vue'),
            meta: { showTransparentNavbar: false }
          },
          // {
          //   name: 'resources-income-dist-updates',
          //   path: '/blank',
          //   beforeEnter() { window.open('https://affinhwangam.com/in-the-spotlight/income-distribution-updates', '_blank') },
          //   component: () => import('/')
          // },
        ]
      },

      {
        path: 'happenings',
        component: {render: (c) => c('router-view')},
        children: [
          {
            name: 'happenings',
            path: '/',
            component: () => import('../pages/Happenings/Main.vue'),
            meta: { showTransparentNavbar: true }
          },
          {
            name: 'campaigns',
            path: 'campaigns',
            component: () => import('../pages/Happenings/Campaign.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'training',
            path: 'training',
            component: () => import('../pages/Happenings/Training.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'featured',
            path: 'featured',
            component: () => import('../pages/Happenings/Featured.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'events',
            path: 'events',
            component: () => import('../pages/Happenings/Events.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'webinars',
            path: 'webinars',
            component: () => import('../pages/Happenings/Webinars.vue'),
            meta: { showTransparentNavbar: false }
          },
          {
            name: 'gallery',
            path: 'gallery',
            component: () => import('../pages/Happenings/Gallery.vue'),
            meta: { showTransparentNavbar: false }
          },
          // {
          //   name: 'news',
          //   path: 'news',
          //   component: () => import('../pages/Happenings/News.vue'),
          //   meta: { showTransparentNavbar: false }
          // },

        ]
      },

      {
        path: '/consultant',
        component: () => import('../layouts/ConsultantLayout.vue'),
        children: [
          {
            name: 'consultant-homepage',
            path: 'home',
            component: () => import('../pages/Consultant/Home.vue')
          },
          {
            name: 'consultant-training',
            path: 'upcoming-training',
            component: () => import('../pages/Consultant/UpcomingTraining.vue')
          },
          {
            name: 'events-webinar',
            path: 'events-webinar',
            component: () => import('../pages/Consultant/EventsWebinar.vue')
          },
          {
            name: 'campaign',
            path: 'campaign',
            component: () => import('../pages/Consultant/Campaign.vue')
          },
          {
            name: 'hall-of-fame',
            path: 'hall-of-fame',
            component: () => import('../pages/Consultant/HallOfFame.vue')
          },
          {
            name: 'my-resource-centre',
            path: 'my-resource-centre',
            component: () => import('../pages/Consultant/MyResourceCentre/index.vue')
          },
          {
            name: 'training-details',
            path: 'my-resource-centre/training/:id',
            component: () => import('../pages/Consultant/MyResourceCentre/training.vue')
          },
          {
            name: 'video-details',
            path: 'my-resource-centre/video/:id',
            component: () => import('../pages/Consultant/MyResourceCentre/video.vue')
          },
          {
            name: 'announcement-details',
            path: 'my-resource-centre/announcement/:id',
            component: () => import('../pages/Consultant/MyResourceCentre/announcement.vue')
          },
          {
            name: 'list-of-consultant',
            path: 'hall-of-fame/list-of-consultants',
            component: () => import('../pages/Consultant/ListOfConsultant.vue')
          },
        ],
        meta: { requiresAuth: true }
      },

      {
        name: 'pb-map',
        path: '/blank',
        beforeEnter() {window.open(process.env.VUE_APP_REDIRECT_MAP + '/Auth/PbWealthAuth?token=' + store.state.auth.token, '_blank')},
        // component: () => import('../pages/Insights/FundUpdates.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        name: 'digital-form',
        path: '/blank',
        beforeEnter() {window.open(process.env.VUE_APP_REDIRECT_DIGITAL_TRANSACTION + '/redirect?token=' + store.state.auth.token + '&path=/Dashboard', '_blank')},
        // component: () => import('../pages/Insights/FundUpdates.vue'),
        meta: { showTransparentNavbar: true }
      },

      {
        name: 'course-registration-form',
        path: 'course-registration-form',
        component: () => import('../pages/CourseRegistrationForm.vue')
      },
      {
        name: 'course-summary',
        path: 'course-summary',
        component: () => import('../pages/CourseSummary.vue')
      },

      {
        name: 'maintenance',
        path: '/maintenance',
        component: () => import('../pages/Maintenance.vue')
      },

      // Login callback path
      {
        name: 'auth-callback',
        path: '/auth/callback',
        beforeEnter: (to, from, next) => {

          if (window.opener) {

            let queryParams = {};
            // Extract "code" from query string in redirect URI
            window.location.search.substr(1).split("&").forEach(function (item) { queryParams[item.split("=")[0]] = item.split("=")[1] });

            // Post message to parent window that spawned the popup window
            window.opener.postMessage({ authQueryString: queryParams }, process.env.VUE_APP_HOSTNAME);
            return window.close();

          }

          let auth_code = to.query.code

          if (!auth_code) {
            sessionStorage.removeItem('verifier')
            sessionStorage.removeItem('token')

            return next({ name: 'homepage' })
          }

          store.dispatch('auth/getToken', auth_code)
            .then(resp => next({ name: 'dashboard' }))
            .catch(err => console.log(err))

        }
      },

      // last route match should be error404
      {
        name: 'error404',
        path: '*',
        component: () => import('../pages/Error404.vue'),
        meta: { showTransparentNavbar: true }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    }
    if (to.hash) {
        return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// Route authorization validator
router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {

    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (!store.getters['auth/isAuthenticated']) {
      return store.dispatch('auth/logout')
    }

    store.dispatch('auth/probeSessioMonitoring', 'router')

    return next();
  }

  return next(); // make sure to always call next()!
});

export default router;
